export const modifySelectedItem = (item, selectedItems) => selectedItems.map((selectedItem) => {
    if (selectedItem.variantId === item.variantId) {
        return { ...item };
    }
    return selectedItem;
});
